import React, { useContext } from 'react';
import _classNames from 'classnames';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Badge from 'components/Badge';
import Typography from '@material-ui/core/Typography';
import { getImageFile } from 'utils/stringUtils';
import { useHistory } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import HeroContext from '../../PageContext';
import getServiceType from '../../utils/getServiceType';
import getFormattedType from '../../utils/getFormattedType';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'block',
  },
  root: {
    background: '#fff',
    boxShadow: '0 0 29px 0 rgba(0,0,0,0.10)',
    borderRadius: 4,
    width: '100%',
    height: 117,
    display: 'flex',
    marginBottom: 20,
    marginTop: 31,
    overflow: 'hidden',
  },
  imgBG: {
    width: 122,
    height: 117,
    background: props => `url(${props.imageSrc}) no-repeat center / cover`,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    letterSpacing: 0,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: 4,
  },
  description: {
    fontSize: 12,
    letterSpacing: 0,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  info: {
    padding: '11px 13px',
  },
  badgeWrapper: {
    '& div': {
      width: '100%',
      margin: 0,
      height: 21,
    },
  },
  grayscale: {
    filter: 'grayscale(1)',
  },
}));
function Firstard({ data, clickHandler }) {
  const imageSrc = getImageFile(data);
  const { landingInfo } = useContext(HeroContext);
  const history = useHistory();
  const {
    title,
    slug,
    name,
    article,
    description,
    shortDescription,
    url,
    __typename = '',
  } = data;
  const classes = useStyles({ imageSrc });
  const routeType = getServiceType(data);
  const type = getFormattedType(data);
  const link = `/${routeType}/${slug}`;
  // TODO: make this common once we have a winner
  const redirect = () => {
    if (type === 'source' || type === 'link') {
      const isInternal =
        url && (url.includes('crediblemind.com') || url.startsWith('/'));
      if (isInternal) {
        const isActivity = __typename === 'Activity' || type === 'articles';
        const redirectUrl = isActivity
          ? `/articles/${slug}`
          : url.split('crediblemind.com')[1] || url;
        clickHandler('Client Resource Card Clicked - Home', {
          article: name || title || article,
          type,
          slug,
          resource: url,
        });
        history.push(redirectUrl);
      } else {
        clickHandler('Client Resource Card Exited - Home', {
          name: name || title || article,
          type,
          slug,
          exitPage: url,
        });
        window.open(url, '_blank', 'noopener');
      }
    } else {
      clickHandler('Resource Card - Clicked', {
        name: name || title || article,
        type,
        slug,
      });
      history.push(link);
    }
  };

  const shouldApplyGrayscaleFilter = _get(
    landingInfo,
    'pageText.grayscale',
    false,
  );

  return (
    <ButtonBase disableRipple onClick={redirect} className={classes.container}>
      <Grid item xs={12} className={classes.root}>
        <div>
          <div
            className={_classNames(classes.imgBG, {
              [classes.grayscale]: shouldApplyGrayscaleFilter,
            })}
          />
        </div>
        <div className={classes.info}>
          <div className={classes.badgeWrapper}>
            <Badge type={type} data={data} />
          </div>
          <Typography
            className={classes.title}
            color="textPrimary"
            align="left"
          >
            {title || name || article}
          </Typography>
          {type === 'topic' && (
            <Typography className={classes.description} color="textPrimary">
              {shortDescription || description}
            </Typography>
          )}
        </div>
      </Grid>
    </ButtonBase>
  );
}

Firstard.propTypes = {
  data: PropTypes.object,
  clickHandler: PropTypes.func,
};

export default Firstard;
